/* eslint-disable no-unused-vars */
import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import { Grid, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";
import { useDispatch, useSelector } from "react-redux";
import { usePopupManager } from "../../providers/PopupManager/PopupManager";
import GridOverlayLoadingSpinner from "../GridOverlayLoadingSpinner/GridOverlayLoadingSpinner";
import { EXPORT_TYPE } from "../../constants";
import StyledButton from "../StyledButton/StyledButton";
import AlertModal from "../AlertModal/AlertModal";

const useStyles = makeStyles((theme) => ({
  heading: {
    fontWeight: "bold",
    color: theme.palette.primary.headingColor,
    fontSize: theme.spacing(3),
  },
  searchBox: {
    maxWidth: 300, // Adjust width of the search box
  },
  searchInput: {
    "& .MuiOutlinedInput-root": {
      marginTop: 1,
      backgroundColor: theme.palette.primary.background,
    },
  },
  downloadExcelBtn: {
    marginLeft: 5,
    borderRadius: 25,
    padding: 8,
    marginRight: 5,
    background: `linear-gradient(${theme.palette.primary.mediumTeal},${theme.palette.primary.royalBlue})`,
    "&:hover": {
      borderColor: theme.palette.primary.primaryBlue,
      background: `linear-gradient(${theme.palette.primary.mediumTeal},${theme.palette.primary.royalBlue})`,
    },
    "&.Mui-disabled": {
      color: theme.palette.common.white,
      backgroundColor: theme.palette.grey[500],
    },
  },
  closeButton: {
    background: theme.palette.common.white,
    color: theme.palette.common.black,
    borderColor: theme.palette.primary.azureBlue,
  },
  button: {
    width: "20%",
    height: 40,
    padding: "10px 25px",
  },
  reprocessBtn: {
    background: `linear-gradient(to right,#00A19A,#4582E8,#2F7DFF)`,
    color: theme.palette.common.white,
    borderRadius: 8,
    borderColor: theme.palette.primary.primaryBlue,
    "&:hover": {
      borderColor: theme.palette.primary.primaryBlue,
    },
    "&.Mui-disabled": {
      color: theme.palette.common.white,
      backgroundColor: theme.palette.grey[500],
    },
  },
  customBtn: {
    width: "auto",
    background: `linear-gradient(to right,#00A19A,#4582E8,#2F7DFF)`,
    color: theme.palette.common.white,
    borderRadius: 8,
    borderColor: theme.palette.primary.primaryBlue,
    "&:hover": {
      borderColor: theme.palette.primary.primaryBlue,
    },
    "&.Mui-disabled": {
      color: theme.palette.common.white,
      backgroundColor: theme.palette.grey[500],
    },
  },
}));

const TableHeader = ({
  heading,
  searchQuery,
  searchPlaceholder,
  onSearchChange,
  customButton,
  onCustomButtonClick = () => {},
  onDownloadPdf = () => {},
  onDownloadExcel = () => {},
}) => {
  const classes = useStyles();
  const [isLoading, setIsLoading] = useState(false);
  // const [errorMessage, setErrorMessage] = useState(null);
  const { showError } = usePopupManager();
  const { user } = useSelector((state) => state.auth);
  const [showReportModal, setShowReportModal] = useState(false);
  const [showAlertModal, setShowAlertModal] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const dispatch = useDispatch();

  const location = useLocation();
  const currentURL = location.pathname;

  const onSelectExportType = (type) => {
    if (type === EXPORT_TYPE.PDF) {
      onDownloadPdf();
    } else {
      onDownloadExcel();
    }
    setShowReportModal(false);
  };

  return (
    <>
      {isLoading && <GridOverlayLoadingSpinner />}
      <Grid container alignItems="center" justifyContent="space-between">
        {/* Heading */}
        <Grid item md={6}>
          <Typography variant="h6" className={classes.heading}>
            {heading}
          </Typography>
        </Grid>

        {/* Search Box and Icon Button */}
        <Grid item md={6}>
          <Grid container justify="flex-end" alignItems="center" spacing={1}>
            {customButton && (
              <StyledButton
                variant="outlined"
                classNames={`${classes.button} ${classes.customBtn}`}
                onClick={onCustomButtonClick}
              >
                {customButton}
              </StyledButton>
            )}
          </Grid>
        </Grid>
      </Grid>
      
      <AlertModal
        open={showAlertModal}
        handleClose={() => {
          setShowAlertModal(false);
        }}
        messsage={errorMessage}
      />
    </>
  );
};

TableHeader.propTypes = {
  heading: PropTypes.string,
  searchPlaceholder: PropTypes.string,
  searchQuery: PropTypes.string,
  customButton: PropTypes.string,
  onCustomButtonClick: PropTypes.func,
  onSearchChange: PropTypes.func,
  onDownloadPdf: PropTypes.func,
  onDownloadExcel: PropTypes.func,
};

export default TableHeader;
